import { HTMLAttributes } from 'react';
import styles from './card.module.css';
import classNames from 'classnames';

export type ICardProps = HTMLAttributes<HTMLDivElement>;

export const Card = ({ children, className, ...props }: ICardProps) => {
  return (
    <div className={`${styles.card} ${className}`} {...props}>
      {children}
    </div>
  );
};

interface CardContentProps extends HTMLAttributes<HTMLDivElement> {
  standalone?: boolean;
}

export const CardContent = ({
  children,
  className,
  standalone = false,
  ...props
}: CardContentProps) => {
  return (
    <div
      className={classNames(
        styles.card__content,
        {
          [styles['card__content--standalone']]: standalone,
        },
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
